import React from 'react'
import CopyClipboard from '../../components/common/CopyClipboard'

export const TooltipTitle = (props) => {
  const { record } = props
  return (
    <div className="tooltip-inner-w">
      <div className="tooltip-inner-header">
        <h3>职位描述：</h3>
        <span className="copy-btn-w">
          <CopyClipboard text={record.positionDesc}/>
        </span>
      </div>
      <div className="editor-cell" dangerouslySetInnerHTML={{ __html: record.positionDesc}}/>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/recruitment/tooltipTitle.js